import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickFilter from '@/components/brick_filter.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-filter', 'text-white']
infos.name = 'filter'
infos.associated_class_name = 'AutomlFilter'
infos.editing_component_name = 'BrickFilter'
infos.editing_component = BrickFilter
infos.descriptions = {
	en: {
		short_tooltip_description: 'Filter',
		full_tooltip_description: 'Filter rows of a table',
		navbar_name: 'Filter',
	},
	fr: {
		short_tooltip_description: 'Filtre',
		full_tooltip_description: "Filtre les lignes d'une table",
		navbar_name: 'Filtre',
	},
}
// infos.short_tooltip_description = 'filter_short_tooltip'
// infos.full_tooltip_description = 'filter_full_tooltip'
// infos.navbar_name = 'filter_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
